const Routes = Object.freeze({
  DASHBOARD: '/',
  ONBOARDING: '/onboarding',
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  CONFIRM_EMAIL: '/confirm-email',
  PAYMENT_SELECT: '/payment-select',
  CREDITS: '/credits',
  DATA_TABLE: '/data-table',
  INPUTS: '/inputs',
  SANDBOX: '/sandbox',
  EMAIL_TEMPLATE: '/email-template',
  PASSWORD_CHANGED_CONFIRMATION: '/password-changed',
  EMAIL_CHANGED_CONFIRMATION: '/email-changed',
  SESSION_ARCHIVE: '/sessions',
  SESSION_DETAIL: '/session/:id',
  ACCOUNT: '/account',
  PRIVACY_POLICY: '/privacy-policy',
  COMMON_INTAKE: '/common-intake',
  CLARITY_DIAGNOSTIC_LAYER: '/clarity-diagnostic-layer',
  RECOMMENDATION_ENGINE: '/recommendation-engine',
  ADMIN: '/admin',
  ADMIN_SESSION_DETAIL: '/admin/sessions/:id',
  ADMIN_USERS: '/admin/users',
  ADMIN_ORGANIZATIONS: '/admin/organizations',
  ADMIN_ESCALATIONS: '/admin/escalations',
} as const);

export default Routes;

export type AvailableRoutes = (typeof Routes)[keyof typeof Routes];
